import * as React from 'react'
import { IconsModel } from './types/iconsModel'

const SvgCheckOk = (
	{
		color,
		width = 115,
		height = 115
	}: IconsModel
) => (
	<svg
		data-name="Composant 9 \u2013 9"
		xmlns="http://www.w3.org/2000/svg"
		width={width}
		height={height}
		viewBox="0 0 115 115"
	>
		<g data-name="Groupe 1142">
			<rect
				data-name="Rectangle 670"
				width={width}
				height={height}
				rx={width / 2}
				fill={color}
			/>
			<g data-name="Groupe 1141">
				<g data-name="Groupe 449">
					<path
						data-name="Ligne 28"
						fill="none"
						stroke="#fff"
						strokeLinecap="square"
						strokeWidth={3}
						d="M55.345 71.618 37.534 53.807"
					/>
				</g>
				<g data-name="Groupe 450">
					<path
						data-name="Ligne 28"
						fill="none"
						stroke="#fff"
						strokeLinecap="square"
						strokeWidth={3}
						d="m55.346 71.617 28.12-28.12"
					/>
				</g>
			</g>
		</g>
	</svg>
)

export default SvgCheckOk

